// @flow

import React from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import GlobalStyles from 'shared/GlobalStyles';
import store from './store';
import MainAppBootstrapper from './MainAppBootstrapper';
import SignIn from './scenes/SignIn';
import SignUp from './scenes/SignUp';
import Dashboard from './scenes/Dashboard';
import Reports from './scenes/Reports';
import Report from './scenes/Report';
import Orders from './scenes/Orders';
import Order from './scenes/Order';
import Jobs from './scenes/Jobs';
import Job from './scenes/Job';
import PendingOrders from './scenes/Jobs/PendingOrders';
import Customers from './scenes/Customers';
import Customer from './scenes/Customer';
import Items from './scenes/Items';
import BomInquiry from './scenes/BomInquiry';
import Help from './scenes/Help';
import Settings from './scenes/Settings';
import ProductionSchedule from './scenes/ProductionSchedule';
import Item from './scenes/Item';
import Lots from './scenes/Lots';
import Lot from './scenes/Lot';
import WarehouseLocations from './scenes/WarehouseLocations';
import Vendors from './scenes/Vendors/VendorList';
import PurchaseOrders from './scenes/PurchaseOrders/PurchaseOrderList';
import PurchaseOrderDetail from './scenes/PurchaseOrders/PurchaseOrderDetail';
import MaterialRequirements from './scenes/PurchaseOrders/MaterialRequirements';
import LowStockList from './scenes/PurchaseOrders/LowStockList';
import GenerationHistory from './scenes/PurchaseOrders/GenerationHistory';
import ApprovalDashboard from './scenes/PurchaseOrders/ApprovalDashboard';
import ReceivingInterface from './scenes/PurchaseOrders/ReceivingInterface';
import ReceiptHistory from './scenes/PurchaseOrders/ReceiptHistory';
import Shipments from './scenes/Shipments';
import ShipmentDetail from './scenes/Shipment';
import Invoices from './scenes/Invoices';
import InvoiceDetail from './scenes/Invoice';
import Backorders from './scenes/Backorders';
import BackorderDetail from './scenes/Backorder';
import Returns from './scenes/Returns';
import ReturnOrderDetail from './scenes/ReturnOrder';
import SalesAnalytics from './scenes/SalesAnalytics';
import Qc from './scenes/Qc';
import ChartOfAccounts from './scenes/ChartOfAccounts';
import JournalEntries from './scenes/JournalEntries';
import AccountMappings from './scenes/AccountMappings';
import FinanceDashboard from './scenes/FinanceDashboard';
import POUpload from './scenes/POUpload';
import CSVImport from './scenes/CSVImport';
import AiChat from './components/AiChat';

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <>
        <MainAppBootstrapper>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
            <Route exact path="/signin" component={SignIn} />
            <Route exact path="/signup" component={SignUp} />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/reports" component={Reports} />
            <Route exact path="/report/:id" component={Report} />
            <Route exact path="/orders" component={Orders} />
            <Route exact path="/order/:id/:section?" component={Order} />
            <Route exact path="/po-upload" component={POUpload} />
            <Route exact path="/jobs" component={Jobs} />
            <Route exact path="/jobs/pending-orders" component={PendingOrders} />
            <Route exact path="/job/:id/:section?" component={Job} />
            <Route
              exact
              path="/production-schedule"
              component={ProductionSchedule}
            />
            <Route exact path="/customers" component={Customers} />
            <Route exact path="/customer/:id/:section?" component={Customer} />
            <Route exact path="/items" component={Items} />
            <Route exact path="/bom-inquiry" component={BomInquiry} />
            <Route exact path="/item/:id/:section?" component={Item} />
            <Route exact path="/lots" component={Lots} />
            <Route exact path="/lot/:id/:section?" component={Lot} />
            <Route exact path="/warehouse-locations" component={WarehouseLocations} />
            <Route exact path="/vendors" component={Vendors} />
            <Route exact path="/purchase-orders" component={PurchaseOrders} />
            <Route exact path="/purchase-order/:id" component={PurchaseOrderDetail} />
            <Route exact path="/purchase-order/:id/receive" component={ReceivingInterface} />
            <Route exact path="/purchase-order/:id/receipts" component={ReceiptHistory} />
            <Route exact path="/purchase-orders/approvals" component={ApprovalDashboard} />
            <Route exact path="/purchase-orders/receipt-history" component={ReceiptHistory} />
            <Route exact path="/material-requirements" component={MaterialRequirements} />
            <Route exact path="/low-stock-items" component={LowStockList} />
            <Route exact path="/purchase-orders/generation-history" component={GenerationHistory} />
            <Route exact path="/shipments" component={Shipments} />
            <Route exact path="/shipment/:id" component={ShipmentDetail} />
            <Route exact path="/invoices" component={Invoices} />
            <Route exact path="/invoice/:id" component={InvoiceDetail} />
            <Route exact path="/backorders" component={Backorders} />
            <Route exact path="/backorder/:id" component={BackorderDetail} />
            <Route exact path="/returns" component={Returns} />
            <Route exact path="/return/:id" component={ReturnOrderDetail} />
            <Route exact path="/sales-analytics" component={SalesAnalytics} />
            <Route exact path="/qc" component={Qc} />
            <Route exact path="/finance-dashboard" component={FinanceDashboard} />
            <Route exact path="/chart-of-accounts" component={ChartOfAccounts} />
            <Route exact path="/journal-entries" component={JournalEntries} />
            <Route exact path="/account-mappings" component={AccountMappings} />
            <Route exact path="/data-import" component={CSVImport} />
            <Route exact path="/help" component={Help} />
            <Route path="/settings" component={Settings} />
            <Route exact render={() => <Redirect to="/dashboard" />} />
          </Switch>
        </MainAppBootstrapper>
        <GlobalStyles />
      </>
    </BrowserRouter>
  </Provider>
);

export default hot(App);
